export default {
  // Page title
  'page.title': 'Timer',
  
  // Popular timers
  'popular.title': 'Popular Timers',
  'popular.10s': '10 Seconds Timer',
  'popular.20s': '20 Seconds Timer',
  'popular.30s': '30 Seconds Timer',
  'popular.40s': '40 Seconds Timer',
  'popular.50s': '50 Seconds Timer',
  'popular.90s': '1.5 Minute Timer',
  'popular.2minute': '2 Minute Timer',
  'popular.3minute': '3 Minute Timer',
  'popular.5minute': '5 Minute Timer',
  'popular.10minute': '10 Minute Timer',
  'popular.15minute': '15 Minute Timer',
  'popular.30minute': '30 Minute Timer',
  'popular.60minute': '60 Minute Timer',
  'popular.1hour': '1 Hour Timer',
  'popular.10hour': '10 Hours Timer',
  'popular.24hour': '24 Hours Timer',
  'popular.48hour': '48 Hours Timer',
  
  // How to use
  'howto.title': 'How to Set a Timer',
  'howto.titleMinutes': 'How to Set a {{minutes}} Minute Timer',
  'howto.titleSeconds': 'How to Set a {{seconds}} Seconds Timer',
  'howto.titleHour': 'How to Set a {{hours}} Hour Timer',
  'howto.titleHours': 'How to Set a {{hours}} Hours Timer',
  'howto.step1': '⚙️ Set Your Time: Click on hour or minute numbers to directly edit time. You can set up to 23 hours and 59 minutes for any task.',
  'howto.step2': '⚡ Quick Time Adjust: Use convenient quick-add buttons to instantly add 30 seconds, 1 minute, 5 minutes, 10 minutes, or 30 minutes to your timer.',
  'howto.step3': '▶️ Start & Control: Click "Start" to begin countdown. You can pause anytime to take breaks and resume when ready, or reset to start over.',
  'howto.step4': '🔔 Get Notified: Receive desktop notifications and customizable sound alerts when time\'s up. Toggle sound on/off in the top-right corner.',
  'howto.step5': '🖥️ Fullscreen Mode: Click the fullscreen button for distraction-free timing - perfect for presentations, meditation, or focused work sessions.',
  'howto.step6': '📱 Works Everywhere: Use on any device - desktop, tablet, or mobile. No download required, works directly in your browser.',
  
  // User review submission
  'reviewSubmission.title': 'Share Your Experience',
  'reviewSubmission.subtitle': 'Help others discover this timer by sharing your experience',
  'reviewSubmission.ratingLabel': 'Rate your experience',
  'reviewSubmission.commentLabel': 'Your review (optional)',
  'reviewSubmission.commentPlaceholder': 'Tell us how this timer helped you with productivity, cooking, studying, or any other activities...',
  'reviewSubmission.nameLabel': 'Your name (optional)',
  'reviewSubmission.namePlaceholder': 'How should we display your name?',
  'reviewSubmission.submitButton': 'Submit Review',
  'reviewSubmission.thankYou': 'Thank you for your review!',
  'reviewSubmission.thankYouMessage': 'Your feedback helps us improve and helps others discover our timer.',
  'reviewSubmission.error': 'Please select a rating before submitting.',

  // User reviews
  'reviews.title': 'What Our Users Say',
  'reviews.newReview': 'New Review',
  'reviews.mikeZhang': 'Game-changer for my productivity! The Pomodoro Technique with this timer helped me finish my thesis. Clean interface, no distractions.',
  'reviews.lisaLee': 'Perfect for kitchen timing! Never overcook eggs again. The sound alerts are loud enough but not annoying. My elderly mom loves it too.',
  'reviews.johnDeveloper': 'Best coding break timer ever! Preset buttons save so much time. Helps prevent eye strain and keeps me focused during sprints.',
  'reviews.msChen': 'Transformed my classroom management! Students actually enjoy timed activities now. The visual countdown keeps everyone engaged.',
  'reviews.fitnessPro': 'Revolutionary for HIIT workouts! Accurate timing, easy controls even with sweaty hands. My clients love the fullscreen mode.',
  'reviews.sarahMarketer': 'Boosted my meeting efficiency by 40%! No more endless discussions. Time limits force decisions and keep everyone focused.',
  'reviews.tomChef': 'Essential in my restaurant kitchen! Pasta, steaks, sauces - perfect timing every time. The multiple quick-add buttons are genius.',
  'reviews.amyStudent': 'Study game-changer! Breaks procrastination cycle with manageable time chunks. Went from C grades to A\'s using this method.',
  'reviews.davidWriter': 'Cured my writer\'s block! 15-minute writing sprints create momentum. Published 3 articles this month thanks to this timer.',
  'reviews.rachelTherapist': 'Perfect for meditation sessions with clients. The gentle alerts don\'t break the peaceful atmosphere. Highly professional.',
  // Preset timer specific reviews
  'reviews.managerZhang': 'Essential for office work! Perfect for tea brewing and meeting breaks, clean interface won\'t distract from work.',
  'reviews.mrsLi': 'Perfect egg timer! 3-minute soft-boiled eggs turn out perfect every time, sound alerts are very thoughtful, no overcooked eggs.',
  'reviews.programmerWang': 'Essential for eye exercises during coding breaks, 3 minutes is just right for relaxing eye muscles, great for vision protection!',
  
  // Use cases
  'useCases.title': '{{minutes}} Minute Timer Use Cases',
  'useCases.titleSeconds': '{{seconds}} Seconds Timer Use Cases',
  'useCases.titleHours': '{{hours}} Hours Timer Use Cases',

  // Page titles
  'pageTitle': '{{minutes}} Minute Timer',
  'pageTitleSeconds': '{{seconds}} Seconds Timer',
  'pageTitleHour': '{{hours}} Hour Timer',
  'pageTitleHours': '{{hours}} Hours Timer',
  
  // User names
  'user.mikeZhang': 'Mike Zhang',
  'user.lisaLee': 'Lisa Lee', 
  'user.johnDeveloper': 'John Developer',
  'user.msChen': 'Ms. Chen',
  'user.fitnessPro': 'Fitness Pro',
  'user.sarahMarketer': 'Sarah Marketer',
  'user.tomChef': 'Tom Chef',
  'user.amyStudent': 'Amy Student',
  'user.davidWriter': 'David Writer',
  'user.rachelTherapist': 'Rachel Therapist',
  // Preset timer specific users
  'user.managerZhang': 'Manager Zhang',
  'user.mrsLi': 'Mrs. Li',
  'user.programmerWang': 'Programmer Wang',

  // Use cases
  'useCases.quickBreak.title': 'Quick Break',
  'useCases.quickBreak.desc': 'Short break between work sessions to refresh your mind and prevent burnout',
  'useCases.eyeCare.title': 'Eye Care Reminder',
  'useCases.eyeCare.desc': 'Follow the 20-20-20 rule: every 20 minutes, look at something 20 feet away for 20 seconds',
  'useCases.teaBrewing.title': 'Tea Brewing',
  'useCases.teaBrewing.desc': 'Perfect steeping time for green tea (3min), black tea (5min), or herbal blends',
  'useCases.lightExercise.title': 'Light Exercise',
  'useCases.lightExercise.desc': 'Office stretching, desk yoga, or simple exercises to combat sedentary lifestyle',
  'useCases.meditation.title': 'Mindfulness & Meditation',
  'useCases.meditation.desc': 'Guided breathing exercises, mindfulness practice, or stress relief meditation',
  'useCases.softBoiledEggs.title': 'Cooking Timer',
  'useCases.softBoiledEggs.desc': 'Perfect timing for soft-boiled eggs (5min), pasta cooking, or any kitchen task',
  'useCases.quickReading.title': 'Focused Reading',
  'useCases.quickReading.desc': 'Concentrated reading sessions for books, articles, or study materials',
  'useCases.phoneCall.title': 'Call & Meeting Timer',
  'useCases.phoneCall.desc': 'Keep phone calls on track, limit meeting duration, or time presentations',
  'useCases.focusedWork.title': 'Pomodoro Work Sessions',
  'useCases.focusedWork.desc': 'Classic Pomodoro Technique - 25 minutes of focused work followed by a break',
  'useCases.exercise.title': 'Workout & Training',
  'useCases.exercise.desc': 'High-intensity intervals, circuit training, or specific exercise duration',
  // 15-minute specific
  'useCases.shortMeeting.title': 'Stand-up Meetings',
  'useCases.shortMeeting.desc': 'Quick team updates, daily standups, or brief collaborative discussions',
  'useCases.powerNap.title': 'Power Nap',
  'useCases.powerNap.desc': 'Optimal nap duration for energy boost without grogginess',
  'useCases.learning.title': 'Learning Sessions',
  'useCases.learning.desc': 'Language practice, skill tutorials, or educational video segments',
  'useCases.creativity.title': 'Creative Sprints',
  'useCases.creativity.desc': 'Brainstorming sessions, writing sprints, or artistic practice',
  // 30-minute specific
  'useCases.deepWork.title': 'Deep Work Session',
  'useCases.deepWork.desc': 'Extended focused work with minimal interruptions for complex tasks',
  'useCases.workout.title': 'Complete Workout',
  'useCases.workout.desc': 'Full exercise routine, yoga session, or structured training program',
  'useCases.study.title': 'Study Block',
  'useCases.study.desc': 'Intensive study sessions for exams, research, or skill development',
  'useCases.presentation.title': 'Presentation Practice',
  'useCases.presentation.desc': 'Rehearse speeches, practice pitches, or time presentation delivery',

  // Timer-specific user reviews
  // 1-minute timer users
  'user.officeWorkerAlex': 'Alex Office',
  'user.developerSarah': 'Sarah Dev',
  'user.designerMike': 'Mike Design',
  'reviews.officeWorkerAlex': 'Perfect for quick breaks between meetings! Just 1 minute to stretch and refocus makes a huge difference.',
  'reviews.developerSarah': 'Great for the 20-20-20 rule - every 20 minutes I look at something 20 feet away for 1 minute. My eyes feel much better!',
  'reviews.designerMike': 'I use this for micro-breaks during intensive design work. Short but effective for preventing burnout.',

  // 3-minute timer users  
  'user.teaLoverEmily': 'Emily Tea',
  'user.yogatrainerJohn': 'John Yoga',
  'user.busyMomLisa': 'Lisa Mom',
  'reviews.teaLoverEmily': 'Perfect timing for my green tea! 3 minutes gives the perfect flavor without bitterness. Love the sound alert!',
  'reviews.yogatrainerJohn': 'I use this for quick breathing exercises with clients. 3 minutes is just right for a calming session.',
  'reviews.busyMomLisa': 'Great for timing my kids\' tooth brushing. They actually enjoy the countdown now!',

  // 5-minute timer users
  'user.meditatorZen': 'Zen Master',
  'user.chefTony': 'Chef Tony',
  'user.runnerMia': 'Mia Runner',
  'reviews.meditatorZen': 'Perfect for beginners\' meditation. 5 minutes is manageable yet effective for mindfulness practice.',
  'reviews.chefTony': 'Essential in my kitchen! Perfect timing for soft-boiled eggs every single time. Professional and reliable.',
  'reviews.runnerMia': 'I use this for post-run stretching. 5 minutes ensures I don\'t skip my recovery routine!',

  // 10-minute timer users
  'user.studentDavid': 'David Student',
  'user.managerRachel': 'Rachel Manager',  
  'user.writerJames': 'James Writer',
  'reviews.studentDavid': 'Great for study breaks! 10 minutes is perfect for a mental reset without losing momentum.',
  'reviews.managerRachel': 'I use this for focused reading sessions. 10 minutes of uninterrupted reading really adds up!',
  'reviews.writerJames': 'Perfect for timed writing sprints. The pressure of 10 minutes helps me overcome writer\'s block.',

  // 15-minute timer users
  'user.consultantAmy': 'Amy Consultant',
  'user.teacherBen': 'Ben Teacher',
  'user.freelancerSophie': 'Sophie Freelancer',
  'reviews.consultantAmy': 'Ideal for quick client calls and stand-up meetings. Keeps discussions focused and productive.',
  'reviews.teacherBen': 'I use this for classroom activities and group work. Students stay engaged with the time limit.',
  'reviews.freelancerSophie': 'Perfect Pomodoro sessions! 15 minutes of focused work followed by a break keeps me productive all day.',

  // 30-minute timer users
  'user.executiveRobert': 'Robert Executive',
  'user.fitnessCoachMaya': 'Maya Fitness',
  'user.artistOlivia': 'Olivia Artist',
  'reviews.executiveRobert': 'Excellent for deep work sessions. 30 minutes allows for meaningful progress without overwhelming commitment.',
  'reviews.fitnessCoachMaya': 'Perfect for complete workout circuits. My clients love the structured timing for different exercises.',
  'reviews.artistOlivia': 'Great for creative sessions. 30 minutes gives enough time to get into the flow state and create something meaningful.',
};